export default "__VITE_ASSET__32172209__"